// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1PaA3","name":"ConsentHeader_name__2eqh6","birthday":"ConsentHeader_birthday__3BU60","skeleton":"ConsentHeader_skeleton__2A2dH"};